module.exports = __webpack_public_path__ + "img/read-more-arrow.2e76ee17.svg";